exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".judge-selector .multiselect-option span.af-icons{vertical-align:middle;margin-left:2px;padding-bottom:3px}", ""]);

// exports
